<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}');background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="5">
              <v-card class="elevation-12">
                <v-col class="d-flex justify-center pt-12">
                 <v-avatar size="400" max-height="60px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>

                <v-card-title class="d-flex justify-center pt-0">
                  <h5 class="text--disabled font-weight-light">
                    Ativação da conta
                  </h5>
                </v-card-title>

                <v-card-text>
                <core-form
                  v-show="!msgResetError && validToken"
                  :submit="ativarUsuario"
                >
                    <v-col class="pb-0">
                      <input-text
                        label="Usuário"
                        v-model="model.Email"
                        :disabled="true"
                      />
                    </v-col>
                    <v-col class="pb-0">
                      <input-text
                        disabled
                        label="Token de ativação"
                        required
                        v-model="model.Token"
                      />
                    </v-col>
                    <v-col cols="12" align="right">
                      <v-btn
                        type="submit"
                        class="font-weight-medium caption text-decoration-none"
                        color="primary"
                        >Confirmar</v-btn
                      >
                    </v-col>
                  </core-form>
                  <v-col cols="12"  v-show="msgResetError" class="pt-0" style="min-height: 80px">
                    <v-alert type="error" class="mt-3 mb-0" text>
                      {{ msgResetError }}
                    </v-alert>
                    <br />
                    <v-btn
                      block
                      color="primary"
                      to="/"
                      class="font-weight-medium caption text-decoration-none"
                      >Voltar ao login</v-btn
                    >
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Ativação'
  },
  props: {
    logoImage: { type: String, default: require('shared/images/svg/logo-black.svg') },
    backgroundImage: {
      type: String,
      default: require('shared/images/svg/background.svg')
    }
  },
  data () {
    return {
      model: { Email: '', Token: '', CodigoUsuario: '' },
      msgResetError: '',
      validToken: true
    }
  },
  methods: {
    ativarUsuario () {
      const th = this
      th.msgResetError = ''
      th.$api.Autenticacao.AtivarUsuario(th.model).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.$api.UI.Mensagem('info', 'Ativação concluída! Faça login novamente.', function () {
            th.$router.push('/')
          }, 'Operação bem sucedida', 'Voltar ao login')
        } else {
          th.msgResetError = response.mensagem
        }
      }).catch((err) => console.log(err));
    }
  },
  mounted: function () {
    const params = this.$route.query
    this.model.Email = params.e
    this.model.CodigoUsuario = params.c
    this.model.Token = params.t
  },
}
</script>
